<script>
    export default {
        name: "MessageDialog",
        props: ['title', 'message', 'show', 'buttontext', 'buttoncolor', 'close', 'width'],
        data() {
            return {}
        },
        watch: {
            isOpen() {
                if(this.value) this.show = true
                else this.show = false
            }
        },
        methods: {
            closeDialog() {
                this.$emit('close')
            },

            accept() {
                this.$emit('accept')
            }

        },
    }
</script>


<template>
    <v-dialog v-model="show" :width="!width ? '512px' : width" persistent>
        <v-card>
            <v-card-title>{{this.title}}</v-card-title>
            <v-card-text>{{this.message}}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text v-if="buttontext" @click="accept" :color="buttoncolor" >{{buttontext}}</v-btn>
                <v-btn text @click="closeDialog" >Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<style lang="scss">

</style>